import qs from 'qs'

export const queryExhibitionEntryBySlug = (options: QueryBySlugOrIdOptions) => {
  const searchKey = strapiGetI18nSlug(options.locale)

  const query = qs.stringify(
    {
      publicationState: options?.publicationState || 'live',
      locale: options?.locale || 'en-US',
      pagination: {
        limit: 1,
      },
      filters: {
        slugs: {
          [searchKey]: {
            $eq: options.slug
          }
        }
      },
      populate: {
        ...queryFragmentCollectionTypeDefault,
        ...queryFragmentBlocks,
        subtitles: true,
        cover_image: true,
        credits: {
          populate: {
            items: true
          }
        },
        publication: {
          populate: {
            i18n_cover_image_en: true,
            i18n_download_en: true,
            i18n_cover_image_al: true,
            i18n_download_al: true
          }
        }
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `exhibition-entries?${query}`
}
